import { create } from 'zustand';
import type { UserProfile } from '@/types';
import { userApi } from '@/api';

interface UserState {
  user: UserProfile | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  fetchUser: () => Promise<void>;
  updateProfile: (data: Partial<UserProfile>) => Promise<void>;
  setOnboarded: () => void;
  logout: () => void;
  setAuth: (accessToken: string, refreshToken: string) => void;
}

export const useUserStore = create<UserState>((set, get) => ({
  user: null,
  isLoading: false,
  isAuthenticated: !!localStorage.getItem('access_token'),

  fetchUser: async () => {
    set({ isLoading: true });
    try {
      const user = await userApi.getMe();
      set({ user, isLoading: false });
    } catch {
      set({ isLoading: false });
    }
  },

  updateProfile: async (data) => {
    const updated = await userApi.updateMe(data);
    set({ user: updated });
  },

  setOnboarded: () => {
    const { user } = get();
    if (user) {
      set({ user: { ...user, is_onboarded: true } });
    }
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    set({ user: null, isAuthenticated: false });
  },

  setAuth: (accessToken, refreshToken) => {
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('refresh_token', refreshToken);
    set({ isAuthenticated: true });
  },
}));
